<template>
  <div class="sidebar-search-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <div class="sidebar-search-wrap">
        <div class="sidebar-logo">
          <svg-icon class-name="sidebar-logo-icon" icon-class="logo" />
        </div>
        <div class="sidebar-product">
          {{ product.title }}
        </div>
        <iw-input
          v-if="false"
          v-model="keyword"
          placeholder="关键字全局搜索"
          prefix-icon="iw-icon-search"
          style="width: 160px;"
          clearable
        />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarSearch",
  props: {
    product: {
      type: Object,
      required: true
    },
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      keyword: ""
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_handle.scss";

.sidebar-search-container {
  position: relative;
  width: 100%;
  background-color: $menuOpenedBg;
  overflow: hidden;
  .sidebar-search-wrap {
    .sidebar-logo {
      margin-top: 16px;

      height: 38px;
      line-height: 38px;
      padding-left: 20px;
      &-icon {
        width: 68px;
        height: 22px;
      }
    }
    .sidebar-product {
      color: $subMenuText;
      font-weight: 600;
      line-height: 38px;
      height: 38px;
      padding: 0 20px;
      font-size: 18px;
      text-align: left;
      margin: 8px 0;
    }

    /deep/ .iw-input {
      margin: 0 10px;
      background-color: #292b33;
      border: 0;

      .iw-input__inner {
        font-size: 12px;
        border-radius: 2px;
        background-color: #292b33;
        border: 1px solid transparent;
        color: #fff;
      }
    }
  }

  &.collapse {
    .sidebar-search-wrap {
      padding: 0;
      h3 {
        display: none;
      }
    }
  }
}
</style>
